import { routerStyxie } from '@/router/styxieBridge'

Styxie.Initializers.MobileServiceTitanJobs = routerStyxie({ actions: ['index', 'show']})
